'use client';

import { Box, CircularProgress, Typography, alpha } from '@mui/material';
import { LocalShipping } from '@mui/icons-material';
import { motion } from 'framer-motion';

const MotionBox = motion.create(Box);

export default function LoadingScreen({ message = 'Loading...' }) {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f8fafc',
        zIndex: 9999,
      }}
    >
      <MotionBox
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
        }}
      >
        {/* Animated Logo */}
        <MotionBox
          animate={{
            y: [0, -10, 0],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
          sx={{
            width: 80,
            height: 80,
            borderRadius: 3,
            bgcolor: '#000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          }}
        >
          <LocalShipping sx={{ fontSize: 40, color: '#fff' }} />
        </MotionBox>

        {/* Progress Indicator */}
        <CircularProgress
          size={48}
          thickness={4}
          sx={{
            color: '#000',
          }}
        />

        {/* Message */}
        <Typography
          sx={{
            fontSize: '1rem',
            fontWeight: 600,
            color: '#374151',
            letterSpacing: '0.5px',
          }}
        >
          {message}
        </Typography>
      </MotionBox>
    </Box>
  );
}
